/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import styled from 'styled-components';

import { useBreakpoint } from 'hooks';
import { Button, Icon } from 'components';
import TourEditContext from '../TourEditContext';
import { StyledTooltipButtonWrapper } from '../StyledComponents';
import { OptimizeStatus } from '../types';
import MobileFriendlyTooltip from '../MobileFriendlyTooltip';

const RouteDirectionActions: React.FC = () => {
  const { optimizeStatus, tourItems, optimizeTour } =
    useContext(TourEditContext);
  const { xs } = useBreakpoint();
  const directionURL = `https://www.google.com/maps/dir/${tourItems
    .map(({ address }) => encodeURIComponent(address))
    .join('/')}`;

  let optimizeTooltip =
    'Optimizing the route will display the quickest route between your first and final destination. The tour will be optimized based on the first listing within the tour.';
  let optimizeDisabled = true;
  if (tourItems.length < 3) {
    optimizeTooltip = 'You need 3 or more stops to find the shortest route';
  } else if (optimizeStatus === OptimizeStatus.OPTIMIZED) {
    optimizeTooltip = 'Tour is already optimized.';
  } else if (optimizeStatus === OptimizeStatus.OPTIMIZING) {
    optimizeTooltip = 'Tour is being optimized.';
  } else {
    optimizeDisabled = false;
  }

  return (
    <StyledActionContainer $xs={xs}>
      <MobileFriendlyTooltip placement="top" title={optimizeTooltip}>
        <StyledTooltipButtonWrapper>
          <StyledButton
            disabled={optimizeDisabled}
            loading={optimizeStatus === OptimizeStatus.OPTIMIZING}
            onClick={optimizeTour}
            data-cy="tours-optimize-button"
          >
            <Icon
              type="optimize"
              color={optimizeDisabled ? 'disabledColor' : 'black'}
              width={10.5}
            />
            Optimize
          </StyledButton>
        </StyledTooltipButtonWrapper>
      </MobileFriendlyTooltip>

      <StyledButton
        data-cy="tours-directions-button"
        onClick={e => {
          e.currentTarget.blur();
          window.open(directionURL, '_blank', 'noopener,noreferrer');
        }}
        disabled={!tourItems.length}
      >
        <Icon
          type="directions"
          color={!tourItems.length ? 'disabledColor' : 'black'}
          width={11.5}
        />
        Directions
      </StyledButton>
    </StyledActionContainer>
  );
};

export default RouteDirectionActions;

const StyledButton = styled(Button)`
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #d9d9d9;
  border-radius: 0;
  box-shadow: 0px 2px rgba(0, 0, 0, 0.016);

  display: flex;
  align-items: center;
  padding: 1px 10px;
  margin-left: 10px;
  height: 24px;

  :hover {
    color: black;
  }
`;

const StyledActionContainer = styled.div<{ $xs: boolean }>`
  display: flex;
  ${({ $xs }) =>
    !$xs &&
    `
    flex-direction: column;
    button:first-child {
      margin-bottom: 5px;
    }
  `}
`;
